module.exports = __webpack_public_path__ + "img/joyride-run-flyknit-womens-running-shoe-HcfnJd.6653bbc1.png";